import { render, staticRenderFns } from "./areaOutfit.vue?vue&type=template&id=2f0a6e21&scoped=true&"
import script from "./areaOutfit.vue?vue&type=script&lang=js&"
export * from "./areaOutfit.vue?vue&type=script&lang=js&"
import style0 from "./areaOutfit.vue?vue&type=style&index=0&id=2f0a6e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a6e21",
  null
  
)

export default component.exports